import React from "react";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import styles from "./NotFound.module.scss";

const NotFound = () => {
    return (
        <AppLayoutWrapFull>
            <div className={styles.error}>
                <p>Page not found</p>
            </div>
        </AppLayoutWrapFull>
    );
};

export default NotFound;
